var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.849609 10.3267C0.849609 6.73152 0.849609 4.93395 1.7063 3.63921C2.08886 3.06105 2.584 2.56591 3.16216 2.18335C4.4569 1.32666 6.25447 1.32666 9.84961 1.32666C13.4447 1.32666 15.2423 1.32666 16.5371 2.18335C17.1152 2.56591 17.6104 3.06105 17.9929 3.63921C18.8496 4.93395 18.8496 6.73152 18.8496 10.3267C18.8496 13.9218 18.8496 15.7194 17.9929 17.0141C17.6104 17.5923 17.1152 18.0874 16.5371 18.47C15.2423 19.3267 13.4447 19.3267 9.84961 19.3267C6.25447 19.3267 4.4569 19.3267 3.16216 18.47C2.584 18.0874 2.08886 17.5923 1.7063 17.0141C0.849609 15.7194 0.849609 13.9218 0.849609 10.3267ZM14.5089 10.3269C14.5089 12.9002 12.4228 14.9863 9.84945 14.9863C7.27613 14.9863 5.19004 12.9002 5.19004 10.3269C5.19004 7.75357 7.27613 5.66748 9.84945 5.66748C12.4228 5.66748 14.5089 7.75357 14.5089 10.3269ZM9.84945 13.4099C11.5521 13.4099 12.9325 12.0296 12.9325 10.3269C12.9325 8.62419 11.5521 7.24388 9.84945 7.24388C8.14675 7.24388 6.76645 8.62419 6.76645 10.3269C6.76645 12.0296 8.14675 13.4099 9.84945 13.4099ZM14.6929 6.52821C15.2975 6.52821 15.7877 6.03804 15.7877 5.43339C15.7877 4.82873 15.2975 4.33856 14.6929 4.33856C14.0882 4.33856 13.5981 4.82873 13.5981 5.43339C13.5981 6.03804 14.0882 6.52821 14.6929 6.52821Z",
    fill: "#FCFCFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.50e3b4f4ef4ac3f7611d60f3355b3b4e.svg";
export { ForwardRef as ReactComponent };